<mat-card class="detail-card" valumizeCardContextMenu [commentScope]="'fund-report-valuation'" [commentSlug]="'fund-cashflows-graph'" [cardChartSource]="cardChartSource">
    <valumize-card-comments-button [commentScope]="'fund-report-valuation'" [commentSlug]="'fund-cashflows-graph'"></valumize-card-comments-button>
    @if (!isSensitivityView) {
        <mat-expansion-panel [expanded]="graphPanelOpenState" class="mat-expansion-panel">
            <mat-expansion-panel-header class="mat-expansion-panel-header">
                <mat-card-title data-test="title">Fund Cashflows Graph</mat-card-title>
            </mat-expansion-panel-header>

            @if ((fundValuationCashflowsGraph$ | async); as graphData) {
                <div class="chart-container" [class.hidden]="graphData.labels.length === 0">
                    <canvas id="FundCashFlowsGraph"></canvas>
                </div>
                @if (graphData.labels.length === 0) {
                    <div class="detail-card-content" style="color: grey">
                        For displaying the cashflow graph, you need to add a fund report, a fund valuation, asset valuations, and some fund details.
                    </div>
                }
            }
        </mat-expansion-panel>
    }

    <mat-expansion-panel [expanded]="scenarioGraphPanelOpenState" class="mat-expansion-panel">
        <mat-expansion-panel-header class="mat-expansion-panel-header">
            <mat-card-title data-test="title">Scenario Cashflows Graphs</mat-card-title>
        </mat-expansion-panel-header>

        <mat-card-content class="detail-card-content">
            <mat-tab-group selectedIndex="0">
                <mat-tab label="Weighted" data-test="tab-weighted">
                    @if ((weightedScenarioCashflowsGraph$ | async); as weightedGraphData) {
                        <div class="chart-container" [class.hidden]="!hasGraphData(weightedGraphData)">
                            <canvas id="WeightedScenarioCashFlowsGraph"></canvas>
                        </div>
                        @if (!hasGraphData(weightedGraphData)) {
                            <div class="detail-card-content" style="color: grey">
                                For displaying the cashflow graph, you need to add a fund report, a fund valuation, asset valuations, and some fund details.
                            </div>
                        }
                    }
                </mat-tab>
                <mat-tab label="Low" data-test="tab-low">
                    @if ((lowScenarioCashflowsGraph$ | async); as lowGraphData) {
                        <div class="chart-container" [class.hidden]="!hasGraphData(lowGraphData)">
                            <canvas id="LowScenarioCashFlowsGraph"></canvas>
                        </div>
                        @if (!hasGraphData(lowGraphData)) {
                            <div class="detail-card-content" style="color: grey">
                                For displaying the cashflow graph, you need to add a fund report, a fund valuation, asset valuations, and some fund details.
                            </div>
                        }
                    }
                </mat-tab>
                <mat-tab label="Base" data-test="tab-base">
                    @if ((baseScenarioCashflowsGraph$ | async); as baseGraphData) {
                        <div class="chart-container" [class.hidden]="!hasGraphData(baseGraphData)">
                            <canvas id="BaseScenarioCashFlowsGraph"></canvas>
                        </div>
                        @if (!hasGraphData(baseGraphData)) {
                            <div class="detail-card-content" style="color: grey">
                                For displaying the cashflow graph, you need to add a fund report, a fund valuation, asset valuations, and some fund details.
                            </div>
                        }
                    }
                </mat-tab>
                <mat-tab label="High" data-test="tab-high">
                    @if ((highScenarioCashflowsGraph$ | async); as highGraphData) {
                        <div class="chart-container" [class.hidden]="!hasGraphData(highGraphData)">
                            <canvas id="HighScenarioCashFlowsGraph"></canvas>
                        </div>
                        @if (!hasGraphData(highGraphData)) {
                            <div class="detail-card-content" style="color: grey">
                                For displaying the cashflow graph, you need to add a fund report, a fund valuation, asset valuations, and some fund details.
                            </div>
                        }
                    }
                </mat-tab>
            </mat-tab-group>
        </mat-card-content>
    </mat-expansion-panel>
</mat-card>
